var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.2308C0 6.81905 6.81905 0 15.2308 0C23.6425 0 30.4615 6.81905 30.4615 15.2308C30.4615 23.6425 23.6425 30.4615 15.2308 30.4615C6.81905 30.4615 0 23.6425 0 15.2308Z",
    fill: "#FF8319"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3105 11.3075L19.3105 11.3075C19.8114 11.6381 20.3919 11.8566 21.0163 11.9252V13.6201C19.974 13.5402 19.011 13.168 18.2068 12.5835L17.535 12.0952V12.9257V18.0755C17.535 20.4186 15.6535 22.3164 13.3528 22.3164C12.4631 22.3164 11.638 22.0328 10.9585 21.5495L10.9584 21.5495C9.87798 20.7814 9.17015 19.5114 9.17015 18.0755C9.17015 15.732 11.0517 13.8342 13.3524 13.8342C13.4183 13.8342 13.4841 13.8361 13.5499 13.8398V15.5303C13.485 15.5249 13.4191 15.5221 13.3524 15.5221C11.9542 15.5221 10.8262 16.6724 10.8262 18.0755C10.8262 19.0547 11.3751 19.9062 12.178 20.334C12.5286 20.5209 12.9281 20.6285 13.3528 20.6285C14.7197 20.6285 15.8246 19.5291 15.8747 18.171L15.875 18.1632L15.875 18.1555L15.8788 8.42308H17.558C17.5689 8.52304 17.5833 8.62163 17.601 8.71872L17.6011 8.71911C17.7989 9.79992 18.4319 10.7276 19.3105 11.3075Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.846154
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.e05b834360634960d38e152964d9799b.svg";
export { ForwardRef as ReactComponent };